import styled from "styled-components";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

StyledList.displayName = "StyledList";

export const StyledListItem = styled.li`
  ${BoxSizingStyle}
  ${FontStyle}

  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 0 1rem;
  margin: 0.25rem 0;
  font-size: 0.875rem;
  user-select: none;

  color: var(--color-theme-900);
  line-height: 28px;

  > svg:first-child {
    margin-right: 8px;
  }

  &:hover,
  &:focus-visible {
    background-color: var(--color-theme-200);
    outline: none;
  }
`;

StyledListItem.displayName = "StyledListItem";

export const StyledListSeparator = styled.div`
  border-top: 1px solid var(--border-primary);
  margin: 12px 16px;
  height: 1px;
`;

StyledListSeparator.displayName = "StyledListSeparator";
